import cookie from 'cookie';

import browserUtil from './browser';

/**
 * Gets a member number if it exists.
 *
 * @returns {string} - Membership ID.
 */
const getOmsMemberNumber = () => {
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'cookie' does not exist on type '{ __productReviewCallbackQueue: { push: LodashNoop; }; __productReviewSettings: {}; activeElement: null; addEventListener: LodashNoop; body: { appendChild: LodashNoop; removeChild: LodashNoop; style: { ...; }; }; ... 8 more ...; supports: LodashNoop; } | Document'.
  const { _mem } = cookie.parse(browserUtil.getDocument()?.cookie ?? '');
  const parsedMem = _mem ? JSON.parse(_mem) : '';
  return parsedMem?.health?.id;
};

export default getOmsMemberNumber;
